const JOB_POSTING_ROUTE_PREFIX = "/job";
const LEGACY_JOB_POSTING_MARKER = "-job-posting-";

export function buildJobPostingPath(slug: string, shortId: string) {
  const slugSegment = buildJobPostingSlugWithIdentifier(slug, shortId);

  return `${JOB_POSTING_ROUTE_PREFIX}/${slugSegment}`;
}

export function buildJobPostingSlugWithIdentifier(slug: string, shortId: string) {
  return `${normalizeJobPostingSlug(slug)}-${shortId}`;
}

export function getShortIdFromSlugWithIdentifier(slugWithIdentifier: string) {
  return slugWithIdentifier.split("-").at(-1) ?? "";
}

export function rewriteLegacyJobPostingPath(pathname: string) {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";

  if (
    normalizedPath === "/" ||
    normalizedPath.startsWith(`${JOB_POSTING_ROUTE_PREFIX}/`) ||
    !normalizedPath.includes(LEGACY_JOB_POSTING_MARKER)
  ) {
    return undefined;
  }

  const match = normalizedPath.match(/^\/(.+)-job-posting-([^-\/]+)$/);

  if (!match) {
    return undefined;
  }

  const [, legacySlug, shortId] = match;

  return buildJobPostingPath(legacySlug ?? "", shortId ?? "");
}

function normalizeJobPostingSlug(slug: string) {
  return slug
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .replaceAll("/", "-");
}
